export default __webpack_public_path__ + "static/media/resign.59553a34.svg";